import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import '../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, Store } from 'redux';
import reduxThunk from 'redux-thunk';
import reducers from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension';

// import i18n (needs to be bundled ;))
import './i18n';
import { ContextProviders } from './ContextProviders';

const store: Store = createStore(reducers, composeWithDevTools(applyMiddleware(reduxThunk)));

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <ContextProviders>
        <App style={{ width: '100%', height: '100%' }} />
      </ContextProviders>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
